import logo from '../../assets/images/logo.png';
import { NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Navbar = () => {
    const [clicked, setClicked] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const handleClick = () => {
        setClicked(!clicked);
    };

    const handleScroll = () => {
        setScrolled(window.scrollY > 0);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
 
    return (
        <nav className={scrolled ? 'navbar scrolled' : 'navbar'}>
            <a href="/">
                <img src={logo} alt="logo" />
            </a>
            <div>
                <ul id="menu_links" className={clicked ? 'active' : ''}>
                    <li><NavLink to="/">Home</NavLink></li>
                    <li><NavLink to="/download">Property Insights</NavLink></li>
                    <li><NavLink to="/services/home-buyers">Home Buying</NavLink></li>
                    <li><NavLink to="/services/investment-properties">Investment Buying</NavLink></li>
                    <li><NavLink to="/services/land-purchases">Land Purchase</NavLink></li>
                    <li><NavLink to="/services/due-deligence">Due Deligence</NavLink></li>
                    <li><NavLink to="/services/auction_negotiation">Auction & Negotiation</NavLink></li>
                    <li><NavLink to="/contact">Contact Us</NavLink></li>
                    <li className='btn'><a href="https://calendly.com/buyersgalaxy/30min?month=2024-11">Book a Call</a></li>
                </ul>
            </div>
            <div id="mobile" onClick={handleClick}>
                <i className={clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
            </div>
        </nav>
    );
};

export default Navbar;